import { FormattedMessage } from 'react-intl';
import React from 'react';
import { LinkAsButton } from '@printdeal/ui-library';
import { useSelectorMachineSend } from '@printdeal/product-selector';
import { dispatchDataLayerEntry } from '../../../../helpers/dataLayerHelpers/productDataLayerHelper';

const ResetSelectorButton = ({ contentfulId }: { contentfulId: string }) => {
  const selectorMachineSend = useSelectorMachineSend();

  const resetSelectorMachine = () => {
    selectorMachineSend({ type: 'Reset machine' });
    dispatchDataLayerEntry(
      'selector',
      'click',
      {
        'element-type': 'button',
        'element-content': 'Reset selector',
        contentfulId,
      },
    );
  };

  return (
    <LinkAsButton variant="secondary" id="reset-product-selectors" onClick={resetSelectorMachine} iconBefore="refresh" className="pd-text-sm">
      <FormattedMessage id="product.configurator.restoreAll" defaultMessage="Restore all" />
    </LinkAsButton>
  );
};

export default ResetSelectorButton;
